import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NewsletterFormComponentDef } from '@df/session/newsletter/newsletter-form.component.def';

@Component({
    selector: 'newsletter-form',
    templateUrl: './newsletter-form.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterFormComponent extends NewsletterFormComponentDef {
    @Output()
    onSubmitSuccess = new EventEmitter<boolean>();

    @Input()
    buttonCopy?: string;

    get canSubmit() {
        return true;
    }

    override ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(this.app.client.obs.breakpoint.subscribe(() => this.detectChanges()));
    }

    protected override onSuccess(): void {
        super.onSuccess();
        this.onSubmitSuccess.emit(true);
    }
}
